import React, { useState, useEffect } from 'react';
import { Badge, Card, Col, Pagination, Row, Table, Form, Spinner, Button } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faFilePdf, faTrash } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from "react-i18next";
import CustomStatusCell1 from '../../CustomStatusCell';
const CustomStatusCell = ({ claim , customStatuses , handleSaveStatus }) => {
      const { t } = useTranslation();
    return (
        <td>
            <CustomStatusCell1
                initialValue={customStatuses[claim._id] || claim.customStatus}
                onSave={(val) => handleSaveStatus(claim._id, val)}
            />
        </td>
    );
};

export default CustomStatusCell;
